// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";

// function Retailer() {
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [deleteShowModals, setDeleteShowModals] = useState(false);
//   const [getdeleteid, setdeleteid] = useState("");
//   const [getdeletename, setdeletename] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedRetailerId, setSelectedRetailerId] = useState(null);
//   const [actionType, setActionType] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // Add Retailer Modal States
//   const [showAddRetailerModal, setShowAddRetailerModal] = useState(false);
//   const [newRetailerId, setNewRetailerId] = useState("");
//   const [addedRetailers, setAddedRetailers] = useState([]);
//   const [addData, setAddData] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//     status: ""
//   });
//   const [formErrors, setFormErrors] = useState({});

//   // Load added retailers from localStorage
//   useEffect(() => {
//     const storedRetailers = localStorage.getItem("addedRetailers");
//     if (storedRetailers) {
//       try {
//         const retailers = JSON.parse(storedRetailers);
//         setAddedRetailers(retailers);
//       } catch (error) {
//         console.error("Error loading added retailers:", error);
//       }
//     }
//   }, []);

//   // Generate Retailer ID
//   const generateRetailerId = () => {
//     const prefix = "TJRET-";
//     const allRetailers = [...responseData, ...addedRetailers];

//     if (!allRetailers.length) return prefix + "001";

//     const lastId = allRetailers
//       .map(r => r.retailer_id)
//       .filter(Boolean)
//       .sort()
//       .pop();

//     if (!lastId) return prefix + "001";

//     const lastNumber = parseInt(lastId.split("-")[1], 10);
//     const nextNumber = (lastNumber + 1).toString().padStart(3, "0");
//     return prefix + nextNumber;
//   };

//   const openAddRetailerModal = () => {
//     setNewRetailerId(generateRetailerId());
//     setAddData({ name: "", mobile: "", address: "", status: "" });
//     setFormErrors({});
//     setShowAddRetailerModal(true);
//   };

//   // Handle form submission
//   const handleAddRetailerSubmit = async () => {
//     setFormErrors({});

//     // Validation
//     const errors = {};
//     if (!addData.name.trim()) errors.name = "Name is required";
//     if (!addData.mobile.trim()) errors.mobile = "Mobile is required";
//     if (addData.mobile.length !== 10) errors.mobile = "Mobile must be 10 digits";
//     if (!addData.address.trim()) errors.address = "Address is required";
//     if (!addData.status) errors.status = "Status is required";

//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }

//     // Create new retailer object
//     const newRetailer = {
//       id: Date.now(),
//       retailer_id: newRetailerId,
//       name: addData.name,
//       mobile: addData.mobile,
//       address: addData.address,
//       status: addData.status,
//       retailer_date: new Date().toISOString(),
//       supplier_id: "-",
//       pure: "-",
//       amount: "-",
//       close: "-",
//       items: [],
//     };

//     // Add to added retailers list
//     const updatedAddedRetailers = [newRetailer, ...addedRetailers];
//     setAddedRetailers(updatedAddedRetailers);

//     // Save to localStorage
//     localStorage.setItem("addedRetailers", JSON.stringify(updatedAddedRetailers));

//     // Add to main response data
//     setResponseData([newRetailer, ...responseData]);

//     setCurrentPage(1);
//     setSearchTerm("");

//     // Reset form
//     setAddData({ name: "", mobile: "", address: "", status: "" });
//     setShowAddRetailerModal(false);

//     toast.success("Retailer added successfully!", 3000, "topRight");

//     // Optional: send to backend
//     try {
//       await axios.post(`${ApiUrl}/Api/retailer_details.php`, newRetailer, {
//         headers: { "Content-Type": "application/json" },
//       });
//       fetchData();
//     } catch (error) {
//       console.error("Error saving retailer:", error);
//     }
//   };

//   const fetchData = async () => {
//     try {
//       const localRole = localStorage.getItem("role");
//       const localUsername = localStorage.getItem("username");
//       const response = await axios.get(
//         localRole === "Employee"
//           ? `${ApiUrl}/Api/retailer_details.php?employee_id=${localUsername}`
//           : `${ApiUrl}/Api/retailer_details.php`
//       );
//       const reversedData = (response.data?.data || []).slice().reverse();
//       setResponseData(reversedData);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     }
//   };

//   const fetchNotifications = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/notification.php`);
//       setNotifications(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching notifications:", error.message);
//       toast.error("Failed to fetch notifications", 3000, "topRight");
//     }
//   };

//   const checkNotificationStatus = (retailerId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === retailerId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "accepted" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const hasPendingNotification = (retailerId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === retailerId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "requested" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const openNotificationModal = (id, action) => {
//     setSelectedRetailerId(id);
//     setActionType(action);
//     setShowModal(true);
//   };

//   const closeNotificationModal = () => {
//     setShowModal(false);
//     setSelectedRetailerId(null);
//     setActionType("");
//     setIsSubmitting(false);
//   };

//   const handleNotificationSubmit = async (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (isSubmitting) return;
//     setIsSubmitting(true);

//     if (hasPendingNotification(selectedRetailerId, actionType)) {
//       toast.warning(
//         "A pending request for this action already exists!",
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       return;
//     }

//     try {
//       const userId = localStorage.getItem("username");
//       const currentTime = new Date()
//         .toISOString()
//         .slice(0, 19)
//         .replace("T", " ");

//       const formData = {
//         table_name: "retailer_details",
//         table_id: selectedRetailerId,
//         employe_id: userId || "",
//         status: "requested",
//         button_value: actionType,
//         time: currentTime,
//         viewed: "false",
//         created_date: currentTime,
//         updated_by: userId || "",
//         updated_date: currentTime,
//       };

//       await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
//         headers: { "Content-Type": "application/json" },
//       });

//       toast.success(
//         `${actionType} request sent successfully!`,
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error submitting notification:", error.message);
//       toast.error(
//         "Error submitting notification. Please try again.",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleUpdateRetailer = (id) => {
//     const userRole = localStorage.getItem("role");
//     const retailer = responseData.find((item) => item.id === id);

//     if (userRole === "Employee") {
//       if (checkNotificationStatus(id, "Edit")) {
//         navigate(`update-retailer/${id}`);
//       } else {
//         openNotificationModal(id, "Edit");
//       }
//     } else {
//       navigate(`update-retailer/${id}`);
//     }
//   };

//   const handleOpenModal = (id, retailer_id) => {
//     const userRole = localStorage.getItem("role");

//     if (userRole === "Employee") {
//       if (checkNotificationStatus(id, "Delete")) {
//         setdeleteid(id);
//         setdeletename(retailer_id);
//         setDeleteShowModals(true);
//       } else {
//         openNotificationModal(id, "Delete");
//       }
//     } else {
//       setdeleteid(id);
//       setdeletename(retailer_id);
//       setDeleteShowModals(true);
//     }
//   };

//   const handleCloseModal = () => {
//     setDeleteShowModals(false);
//     setdeleteid("");
//     setdeletename("");
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await axios.delete(`${ApiUrl}/Api/retailer_details.php/${getdeleteid}`);

//       const notification = notifications.find(
//         (notif) =>
//           notif.table_id === getdeleteid.toString() &&
//           notif.button_value === "Delete" &&
//           notif.viewed === "false"
//       );
//       if (notification) {
//         const currentTime = new Date()
//           .toISOString()
//           .slice(0, 19)
//           .replace("T", " ");
//         const notificationPayload = {
//           id: notification.id,
//           viewed: "true",
//           updated_by: localStorage.getItem("username"),
//           updated_date: currentTime,
//           table_name: notification.table_name,
//           table_id: notification.table_id,
//           employe_id: notification.employe_id,
//           status: notification.status,
//           button_value: notification.button_value,
//           time: notification.time,
//           created_date: notification.created_date,
//         };

//         await axios.put(
//           `${ApiUrl}/Api/notification.php/${notification.id}`,
//           notificationPayload,
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );
//       }

//       toast.success("Retailer deleted successfully!", 3000, "topRight");
//       handleCloseModal();
//       fetchData();
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error deleting data:", error.message);
//       toast.error("Failed to delete data", 3000, "topRight");
//     } finally {
//       setTimeout(() => setLoading(false), 1000);
//     }
//   };

//   const handlePrint = () => {
//     try {
//       const printWindow = window.open("", "_blank");
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Retailer List</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//               th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//               th { background-color: #f2f2f2; font-weight: bold; }
//               .header { text-align: center; margin-bottom: 20px; }
//               .table-secondary { background-color: #e2e3e5; }
//               .table-danger { background-color: #f8d7da; }
//               .table-info { background-color: #cff4fc; }
//             </style>
//           </head>
//           <body>
//             <div class="header"><h2>Retailer List</h2></div>
//             <table>
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Retailer ID</th>
//                   <th>Retailer Date</th>
//                   <th>Supplier Name</th>
//                   <th>Total Items</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${filteredData
//                   .map((item, index) => {
//                     const userId = localStorage.getItem("username");
//                     const notification = notifications.find(
//                       (notif) =>
//                         notif.table_id === item.id.toString() &&
//                         notif.employe_id === userId &&
//                         notif.viewed === "false"
//                     );
//                     let rowClass = "";
//                     if (notification) {
//                       switch (notification.status) {
//                         case "accepted":
//                           rowClass = "table-secondary";
//                           break;
//                         case "rejected":
//                           rowClass = "table-danger";
//                           break;
//                         case "requested":
//                           rowClass = "table-info";
//                           break;
//                       }
//                     }
//                     return `
//                       <tr class="${rowClass}">
//                         <td>${index + 1}</td>
//                         <td>${item.retailer_id || ""}</td>
//                         <td>${formatDate(item.retailer_date) || ""}</td>
//                         <td>${item.supplier_id || ""}</td>
//                         <td>${item.items?.length || ""}</td>
//                       </tr>
//                     `;
//                   })
//                   .join("")}
//               </tbody>
//             </table>
//           </body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//       toast.success("Print dialog opened!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error printing:", error);
//       toast.error("Error printing. Please try again", 3000, "topRight");
//     }
//   };

//   const exportPDF = () => {
//     try {
//       const doc = new jsPDF();
//       doc.setFontSize(20);
//       doc.text("Retailer List", 14, 22);
//       doc.setFontSize(12);
//       doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

//       const tableColumn = [
//         "S.No",
//         "Retailer ID",
//         "Retailer Date",
//         "Supplier Name",
//         "Total Items",
//       ];
//       const tableRows = filteredData.map((item, index) => {
//         const userId = localStorage.getItem("username");
//         const notification = notifications.find(
//           (notif) =>
//             notif.table_id === item.id.toString() &&
//             notif.employe_id === userId &&
//             notif.viewed === "false"
//         );
//         let rowStyle = "";
//         if (notification) {
//           switch (notification.status) {
//             case "accepted":
//               rowStyle = { fillColor: [226, 227, 229] };
//               break;
//             case "rejected":
//               rowStyle = { fillColor: [248, 215, 218] };
//               break;
//             case "requested":
//               rowStyle = { fillColor: [207, 244, 252] };
//               break;
//           }
//         }
//         return [
//           index + 1,
//           item.retailer_id || "",
//           formatDate(item.retailer_date) || "",
//           item.supplier_id || "",
//           item.items?.length || "",
//           rowStyle,
//         ];
//       });

//       autoTable(doc, {
//         head: [tableColumn],
//         body: tableRows.map((row) => row.slice(0, -1)),
//         startY: 45,
//         styles: { fontSize: 8, cellPadding: 2 },
//         headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//         columnStyles: {
//           0: { cellWidth: 15 },
//           1: { cellWidth: 25 },
//           2: { cellWidth: 25 },
//           3: { cellWidth: 30 },
//           4: { cellWidth: 20 },
//         },
//         didParseCell: (data) => {
//           if (data.section === "body") {
//             const rowIndex = data.row.index;
//             const rowStyle =
//               tableRows[rowIndex][tableRows[rowIndex].length - 1];
//             if (rowStyle) {
//               data.cell.styles = { ...data.cell.styles, ...rowStyle };
//             }
//           }
//         },
//       });

//       doc.save("retailer-list.pdf");
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting PDF:", error);
//       toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
//     }
//   };

//   const handleprint = (id, retailer_id) => {
//     navigate(`/retailer-bill/${retailer_id}`);
//   };

//   const copyToClipboard = () => {
//     try {
//       const headers = [
//         "S.No",
//         "Retailer ID",
//         "Retailer Date",
//         "Supplier Name",
//         "Total Items",
//       ];
//       const rows = filteredData.map((item, index) => [
//         index + 1,
//         item.retailer_id || "",
//         formatDate(item.retailer_date) || "",
//         item.supplier_id || "",
//         item.items?.length || "",
//       ]);

//       const formattedText = [headers, ...rows]
//         .map((row) => row.map((field) => `"${field}"`).join("\t"))
//         .join("\n");

//       if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard
//           .writeText(formattedText)
//           .then(() => {
//             toast.success("Data copied to clipboard!", 3000, "topRight");
//           })
//           .catch((err) => {
//             console.error("Clipboard API failed:", err);
//             fallbackCopy(formattedText);
//           });
//       } else {
//         fallbackCopy(formattedText);
//       }
//     } catch (error) {
//       console.error("Unexpected error copying to clipboard:", error);
//       toast.error("Error copying data. Please try again.", 3000, "topRight");
//     }
//   };

//   const fallbackCopy = (text) => {
//     try {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "fixed";
//       textArea.style.top = 0;
//       textArea.style.left = 0;
//       textArea.style.width = "2em";
//       textArea.style.height = "2em";
//       textArea.style.padding = 0;
//       textArea.style.border = "none";
//       textArea.style.outline = "none";
//       textArea.style.boxShadow = "none";
//       textArea.style.background = "transparent";
//       document.body.appendChild(textArea);
//       textArea.focus();
//       textArea.select();
//       const successful = document.execCommand("copy");
//       document.body.removeChild(textArea);
//       if (successful) {
//         toast.success("Data copied to clipboard!", 3000, "topRight");
//       } else {
//         toast.error("Failed to copy data", 3000, "topRight");
//       }
//     } catch (err) {
//       console.error("Fallback copy failed:", err);
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   };

//   const exportCSV = () => {
//     try {
//       const csvData = [
//         [
//           "S.No",
//           "Retailer ID",
//           "Retailer Date",
//           "Supplier Name",
//           "Total Items",
//         ],
//         ...filteredData.map((item, index) => [
//           index + 1,
//           item.retailer_id || "",
//           formatDate(item.retailer_date) || "",
//           item.supplier_id || "",
//           item.items?.length || "",
//         ]),
//       ];

//       const csvContent = csvData
//         .map((row) => row.map((field) => `"${field}"`).join(","))
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute("download", "retailer-list.csv");
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success("CSV exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
//     }
//   };

//   const exportExcel = () => {
//     try {
//       const excelData = filteredData.map((item, index) => ({
//         "S.No": index + 1,
//         "Retailer ID": item.retailer_id || "",
//         "Retailer Date": formatDate(item.retailer_date) || "",
//         "Supplier Name": item.supplier_id || "",
//         "Total Items": item.items?.length || "",
//       }));

//       const ws = XLSX.utils.json_to_sheet(excelData);
//       const wb = XLSX.utils.book_new();
//       const colWidths = [
//         { wch: 8 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 15 },
//       ];
//       ws["!cols"] = colWidths;
//       XLSX.utils.book_append_sheet(wb, ws, "Retailers");
//       XLSX.writeFile(wb, "retailer-list.xlsx");
//       toast.success("Excel file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error);
//       toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
//     }
//   };

//   const fieldsToSearch = ['retailer_id', 'retailer_date', 'supplier_id', 'pure', 'amount', 'close'];

//   const filteredData = responseData.filter((item) => {
//     const searchLower = searchTerm.trim().toLowerCase();
//     return fieldsToSearch.some(
//       (field) => item[field]?.toLowerCase().includes(searchLower)
//     );
//   });

//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return dateString;
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return dateString;
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchNotifications();
//     const interval = setInterval(() => {
//       fetchData();
//       fetchNotifications();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid mb-5">
//         <div className="d-flex mb-2 justify-content-between align-items-center">
//           <div className="d-flex">
//             <h6 className="card-title m-2">Retailer</h6>
//             <button
//               className="btn btn-primary btn-sm rounded-3"
//               onClick={() => navigate("/add-retailer")}
//             >
//               Add <span className="ms-2">+</span>
//             </button>
//           </div>

//           <div className="d-flex gap-2">
//             <button
//               className="btn btn-success btn-sm rounded-3"
//               onClick={openAddRetailerModal}
//             >
//               Add New Retailer <span className="ms-2">+</span>
//             </button>
//             <button
//               className="btn btn-info btn-sm text-white rounded-3"
//               onClick={() => navigate("/added-retailers-list")}
//             >
//               List Added Retailers ({addedRetailers.length})
//             </button>
//           </div>
//         </div>

//         {/* Add Retailer Modal */}
//         <div
//           className={`modal fade ${showAddRetailerModal ? "show" : ""}`}
//           style={{
//             display: showAddRetailerModal ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//           onClick={() => setShowAddRetailerModal(false)}
//         >
//           <div 
//             className="modal-dialog modal-dialog-centered" 
//             style={{ maxWidth: '500px' }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Add New Retailer</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowAddRetailerModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="mb-3">
//                   <label className="form-label">Retailer ID</label>
//                   <input
//                     type="text"
//                     className="form-control bg-light"
//                     value={newRetailerId}
//                     disabled
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Name <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
//                     placeholder="Enter Name"
//                     value={addData.name}
//                     onChange={(e) => setAddData({ ...addData, name: e.target.value })}
//                   />
//                   {formErrors.name && (
//                     <div className="invalid-feedback">{formErrors.name}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Mobile Number <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     inputMode="numeric"
//                     maxLength="10"
//                     className={`form-control ${formErrors.mobile ? "is-invalid" : ""}`}
//                     placeholder="Enter 10-digit Mobile"
//                     value={addData.mobile}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d{0,10}$/.test(value)) {
//                         setAddData({ ...addData, mobile: value });
//                       }
//                     }}
//                   />
//                   {formErrors.mobile && (
//                     <div className="invalid-feedback">{formErrors.mobile}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Address <span className="text-danger">*</span>
//                   </label>
//                   <textarea
//                     className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
//                     placeholder="Enter Address"
//                     rows="2"
//                     value={addData.address}
//                     onChange={(e) => setAddData({ ...addData, address: e.target.value })}
//                   />
//                   {formErrors.address && (
//                     <div className="invalid-feedback">{formErrors.address}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Status <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${formErrors.status ? "is-invalid" : ""}`}
//                     value={addData.status}
//                     onChange={(e) => setAddData({ ...addData, status: e.target.value })}
//                   >
//                     <option value="">Select Status</option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                   {formErrors.status && (
//                     <div className="invalid-feedback">{formErrors.status}</div>
//                   )}
//                 </div>

//                 <div className="d-flex gap-2 justify-content-end mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={() => setShowAddRetailerModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button 
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={handleAddRetailerSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card shadow-sm">
//           <div className="card-body">
//             <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
//               <div className="d-flex">
//                 <label className="form-label text-dark mt-2">Show : </label>
//                 <div>
//                   <select
//                     className="form-control mx-2"
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>

//               <div className="search-container">
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search"
//                     aria-label="Search"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="card tableCard p-2">
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="bg-light">
//                     <tr>
//                       <th scope="col">S.No</th>
//                       <th scope="col">Retailer ID</th>
//                       <th scope="col">Retailer Date</th>
//                       <th scope="col">Supplier Name</th>
//                       <th scope="col">Total Items</th>
//                       <th scope="col">Total Pure</th>
//                       <th scope="col">Total Amount</th>
//                       <th scope="col">Balance</th>
//                       <th scope="col">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((item, index) => {
//                         const userId = localStorage.getItem("username");
//                         const notification = notifications.find(
//                           (notif) =>
//                             notif.table_id === item.id.toString() &&
//                             notif.viewed === "false"
//                         );
//                         let rowClass = "";
//                         if (notification) {
//                           switch (notification.status) {
//                             case "accepted":
//                               rowClass = "table-secondary";
//                               break;
//                             case "rejected":
//                               rowClass = "table-danger";
//                               break;
//                             case "requested":
//                               rowClass = "table-info";
//                               break;
//                           }
//                         }
//                         return (
//                           <tr key={item.id} className={rowClass}>
//                             <td>{index + 1}</td>
//                             <td>{item.retailer_id}</td>
//                             <td>{formatDate(item.retailer_date)}</td>
//                             <td>{item.supplier_id}</td>
//                             <td>{item.items?.length}</td>
//                             <td>{item.pure || "-"}</td>
//                             <td>{item.amount || "-"}</td>
//                             <td>{item.close}</td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleUpdateRetailer(item.id)}
//                               >
//                                 <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light"
//                                 onClick={() =>
//                                   handleOpenModal(item.id, item.retailer_id)
//                                 }
//                               >
//                                 <i className="fa-solid fa-trash text-danger fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light"
//                                 onClick={() =>
//                                   handleprint(item.id, item.retailer_id)
//                                 }
//                               >
//                                 <i className="fa-solid fa-print text-secondary fs-6"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan="9" className="text-center">
//                           No retailers found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="row">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First"
//                         >
//                           <span aria-hidden="true">««</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">«</span>
//                         </button>
//                       </li>
//                       {renderPageNumbers()}
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">»</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last"
//                         >
//                           <span aria-hidden="true">»»</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Notification Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="notificationModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="notificationModalLabel"
//               >
//                 Send {actionType} Request to Admin
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeNotificationModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div>
//                 <p className="text-center">
//                   Do you want to request to {actionType.toLowerCase()} this
//                   retailer?
//                 </p>
//                 <div className="text-center mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm px-4 me-2"
//                     onClick={closeNotificationModal}
//                   >
//                     No
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={isSubmitting}
//                     onClick={handleNotificationSubmit}
//                   >
//                     Yes
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModals ? "show" : ""}`}
//         style={{
//           display: deleteShowModals ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
//                   style={{ width: "80px", height: "80px", margin: "0 auto" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>
//               <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
//               <h6 className="mb-4 text-center">
//                 Do you really want to delete this
//                 <span className="text-primary"> ({getdeletename})</span>?
//               </h6>
//               <div className="d-flex btn-group">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm flex-grow-1"
//                   onClick={handleCloseModal}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {(showModal || deleteShowModals || showAddRetailerModal) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </>
//   );
// }

// export default Retailer;







// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";

// function Retailer() {
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [deleteShowModals, setDeleteShowModals] = useState(false);
//   const [getdeleteid, setdeleteid] = useState("");
//   const [getdeletename, setdeletename] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedRetailerId, setSelectedRetailerId] = useState(null);
//   const [actionType, setActionType] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // Add Retailer Modal States
//   const [showAddRetailerModal, setShowAddRetailerModal] = useState(false);
//   const [newRetailerId, setNewRetailerId] = useState("");
//   const [addedRetailers, setAddedRetailers] = useState([]);
//   const [addData, setAddData] = useState({
//     name: "",
//     mobile: "",
//     address: "",
//     status: ""
//   });
//   const [formErrors, setFormErrors] = useState({});

//   // Added Retailers List Popup States
//   const [showAddedRetailersPopup, setShowAddedRetailersPopup] = useState(false);
//   const [listCurrentPage, setListCurrentPage] = useState(1);
//   const [listItemsPerPage, setListItemsPerPage] = useState(10);
//   const [listShowAllItems, setListShowAllItems] = useState(false);
//   const [listSearchTerm, setListSearchTerm] = useState("");
//   const [listDeleteShowModals, setListDeleteShowModals] = useState(false);
//   const [listGetdeleteid, setListDeleteid] = useState("");
//   const [listGetdeletename, setListDeletename] = useState("");

//   // Load added retailers from localStorage
//   useEffect(() => {
//     const storedRetailers = localStorage.getItem("addedRetailers");
//     if (storedRetailers) {
//       try {
//         const retailers = JSON.parse(storedRetailers);
//         setAddedRetailers(retailers);
//       } catch (error) {
//         console.error("Error loading added retailers:", error);
//       }
//     }
//   }, []);

//   // Generate Retailer ID
//   const generateRetailerId = () => {
//     const prefix = "TJRET-";
//     const allRetailers = [...responseData, ...addedRetailers];

//     if (!allRetailers.length) return prefix + "001";

//     const lastId = allRetailers
//       .map(r => r.retailer_id)
//       .filter(Boolean)
//       .sort()
//       .pop();

//     if (!lastId) return prefix + "001";

//     const lastNumber = parseInt(lastId.split("-")[1], 10);
//     const nextNumber = (lastNumber + 1).toString().padStart(3, "0");
//     return prefix + nextNumber;
//   };

//   const openAddRetailerModal = () => {
//     setNewRetailerId(generateRetailerId());
//     setAddData({ name: "", mobile: "", address: "", status: "" });
//     setFormErrors({});
//     setShowAddRetailerModal(true);
//   };

//   // Handle form submission
//   const handleAddRetailerSubmit = async () => {
//     setFormErrors({});

//     // Validation
//     const errors = {};
//     if (!addData.name.trim()) errors.name = "Name is required";
//     if (!addData.mobile.trim()) errors.mobile = "Mobile is required";
//     if (addData.mobile.length !== 10) errors.mobile = "Mobile must be 10 digits";
//     if (!addData.address.trim()) errors.address = "Address is required";
//     if (!addData.status) errors.status = "Status is required";

//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }

//     // Create new retailer object
//     const newRetailer = {
//       id: Date.now(),
//       retailer_id: newRetailerId,
//       name: addData.name,
//       mobile: addData.mobile,
//       address: addData.address,
//       status: addData.status,
//       retailer_date: new Date().toISOString(),
//       supplier_id: "-",
//       pure: "-",
//       amount: "-",
//       close: "-",
//       items: [],
//     };

//     // Add to added retailers list
//     const updatedAddedRetailers = [newRetailer, ...addedRetailers];
//     setAddedRetailers(updatedAddedRetailers);

//     // Save to localStorage
//     localStorage.setItem("addedRetailers", JSON.stringify(updatedAddedRetailers));

//     // Add to main response data
//     setResponseData([newRetailer, ...responseData]);

//     setCurrentPage(1);
//     setSearchTerm("");

//     // Reset form
//     setAddData({ name: "", mobile: "", address: "", status: "" });
//     setShowAddRetailerModal(false);

//     toast.success("Retailer added successfully!", 3000, "topRight");

//     // Optional: send to backend
//     try {
//       await axios.post(`${ApiUrl}/Api/retailer_details.php`, newRetailer, {
//         headers: { "Content-Type": "application/json" },
//       });
//       fetchData();
//     } catch (error) {
//       console.error("Error saving retailer:", error);
//     }
//   };

//   const fetchData = async () => {
//     try {
//       const localRole = localStorage.getItem("role");
//       const localUsername = localStorage.getItem("username");
//       const response = await axios.get(
//         localRole === "Employee"
//           ? `${ApiUrl}/Api/retailer_details.php?employee_id=${localUsername}`
//           : `${ApiUrl}/Api/retailer_details.php`
//       );
//       const reversedData = (response.data?.data || []).slice().reverse();
//       setResponseData(reversedData);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       toast.error("Failed to fetch data", 3000, "topRight");
//     }
//   };

//   const fetchNotifications = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/notification.php`);
//       setNotifications(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching notifications:", error.message);
//       toast.error("Failed to fetch notifications", 3000, "topRight");
//     }
//   };

//   const checkNotificationStatus = (retailerId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === retailerId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "accepted" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const hasPendingNotification = (retailerId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === retailerId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "requested" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const openNotificationModal = (id, action) => {
//     setSelectedRetailerId(id);
//     setActionType(action);
//     setShowModal(true);
//   };

//   const closeNotificationModal = () => {
//     setShowModal(false);
//     setSelectedRetailerId(null);
//     setActionType("");
//     setIsSubmitting(false);
//   };

//   const handleNotificationSubmit = async (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (isSubmitting) return;
//     setIsSubmitting(true);

//     if (hasPendingNotification(selectedRetailerId, actionType)) {
//       toast.warning(
//         "A pending request for this action already exists!",
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       return;
//     }

//     try {
//       const userId = localStorage.getItem("username");
//       const currentTime = new Date()
//         .toISOString()
//         .slice(0, 19)
//         .replace("T", " ");

//       const formData = {
//         table_name: "retailer_details",
//         table_id: selectedRetailerId,
//         employe_id: userId || "",
//         status: "requested",
//         button_value: actionType,
//         time: currentTime,
//         viewed: "false",
//         created_date: currentTime,
//         updated_by: userId || "",
//         updated_date: currentTime,
//       };

//       await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
//         headers: { "Content-Type": "application/json" },
//       });

//       toast.success(
//         `${actionType} request sent successfully!`,
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error submitting notification:", error.message);
//       toast.error(
//         "Error submitting notification. Please try again.",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleUpdateRetailer = (id) => {
//     const userRole = localStorage.getItem("role");
//     const retailer = responseData.find((item) => item.id === id);

//     if (userRole === "Employee") {
//       if (checkNotificationStatus(id, "Edit")) {
//         navigate(`update-retailer/${id}`);
//       } else {
//         openNotificationModal(id, "Edit");
//       }
//     } else {
//       navigate(`update-retailer/${id}`);
//     }
//   };

//   const handleOpenModal = (id, retailer_id) => {
//     const userRole = localStorage.getItem("role");

//     if (userRole === "Employee") {
//       if (checkNotificationStatus(id, "Delete")) {
//         setdeleteid(id);
//         setdeletename(retailer_id);
//         setDeleteShowModals(true);
//       } else {
//         openNotificationModal(id, "Delete");
//       }
//     } else {
//       setdeleteid(id);
//       setdeletename(retailer_id);
//       setDeleteShowModals(true);
//     }
//   };

//   const handleCloseModal = () => {
//     setDeleteShowModals(false);
//     setdeleteid("");
//     setdeletename("");
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await axios.delete(`${ApiUrl}/Api/retailer_details.php/${getdeleteid}`);

//       const notification = notifications.find(
//         (notif) =>
//           notif.table_id === getdeleteid.toString() &&
//           notif.button_value === "Delete" &&
//           notif.viewed === "false"
//       );
//       if (notification) {
//         const currentTime = new Date()
//           .toISOString()
//           .slice(0, 19)
//           .replace("T", " ");
//         const notificationPayload = {
//           id: notification.id,
//           viewed: "true",
//           updated_by: localStorage.getItem("username"),
//           updated_date: currentTime,
//           table_name: notification.table_name,
//           table_id: notification.table_id,
//           employe_id: notification.employe_id,
//           status: notification.status,
//           button_value: notification.button_value,
//           time: notification.time,
//           created_date: notification.created_date,
//         };

//         await axios.put(
//           `${ApiUrl}/Api/notification.php/${notification.id}`,
//           notificationPayload,
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );
//       }

//       toast.success("Retailer deleted successfully!", 3000, "topRight");
//       handleCloseModal();
//       fetchData();
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error deleting data:", error.message);
//       toast.error("Failed to delete data", 3000, "topRight");
//     } finally {
//       setTimeout(() => setLoading(false), 1000);
//     }
//   };

//   const handlePrint = () => {
//     try {
//       const printWindow = window.open("", "_blank");
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Retailer List</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//               th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//               th { background-color: #f2f2f2; font-weight: bold; }
//               .header { text-align: center; margin-bottom: 20px; }
//               .table-secondary { background-color: #e2e3e5; }
//               .table-danger { background-color: #f8d7da; }
//               .table-info { background-color: #cff4fc; }
//             </style>
//           </head>
//           <body>
//             <div class="header"><h2>Retailer List</h2></div>
//             <table>
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Retailer ID</th>
//                   <th>Retailer Date</th>
//                   <th>Retailer Name</th>
//                   <th>Total Items</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${filteredData
//                   .map((item, index) => {
//                     const userId = localStorage.getItem("username");
//                     const notification = notifications.find(
//                       (notif) =>
//                         notif.table_id === item.id.toString() &&
//                         notif.employe_id === userId &&
//                         notif.viewed === "false"
//                     );
//                     let rowClass = "";
//                     if (notification) {
//                       switch (notification.status) {
//                         case "accepted":
//                           rowClass = "table-secondary";
//                           break;
//                         case "rejected":
//                           rowClass = "table-danger";
//                           break;
//                         case "requested":
//                           rowClass = "table-info";
//                           break;
//                       }
//                     }
//                     return `
//                       <tr class="${rowClass}">
//                         <td>${index + 1}</td>
//                         <td>${item.retailer_id || ""}</td>
//                         <td>${formatDate(item.retailer_date) || ""}</td>
//                         <td>${item.supplier_id || ""}</td>
//                         <td>${item.items?.length || ""}</td>
//                       </tr>
//                     `;
//                   })
//                   .join("")}
//               </tbody>
//             </table>
//           </body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//       toast.success("Print dialog opened!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error printing:", error);
//       toast.error("Error printing. Please try again", 3000, "topRight");
//     }
//   };

//   const exportPDF = () => {
//     try {
//       const doc = new jsPDF();
//       doc.setFontSize(20);
//       doc.text("Retailer List", 14, 22);
//       doc.setFontSize(12);
//       doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

//       const tableColumn = [
//         "S.No",
//         "Retailer ID",
//         "Retailer Date",
//         "Retailer Name",
//         "Total Items",
//       ];
//       const tableRows = filteredData.map((item, index) => {
//         const userId = localStorage.getItem("username");
//         const notification = notifications.find(
//           (notif) =>
//             notif.table_id === item.id.toString() &&
//             notif.employe_id === userId &&
//             notif.viewed === "false"
//         );
//         let rowStyle = "";
//         if (notification) {
//           switch (notification.status) {
//             case "accepted":
//               rowStyle = { fillColor: [226, 227, 229] };
//               break;
//             case "rejected":
//               rowStyle = { fillColor: [248, 215, 218] };
//               break;
//             case "requested":
//               rowStyle = { fillColor: [207, 244, 252] };
//               break;
//           }
//         }
//         return [
//           index + 1,
//           item.retailer_id || "",
//           formatDate(item.retailer_date) || "",
//           item.supplier_id || "",
//           item.items?.length || "",
//           rowStyle,
//         ];
//       });

//       autoTable(doc, {
//         head: [tableColumn],
//         body: tableRows.map((row) => row.slice(0, -1)),
//         startY: 45,
//         styles: { fontSize: 8, cellPadding: 2 },
//         headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//         columnStyles: {
//           0: { cellWidth: 15 },
//           1: { cellWidth: 25 },
//           2: { cellWidth: 25 },
//           3: { cellWidth: 30 },
//           4: { cellWidth: 20 },
//         },
//         didParseCell: (data) => {
//           if (data.section === "body") {
//             const rowIndex = data.row.index;
//             const rowStyle =
//               tableRows[rowIndex][tableRows[rowIndex].length - 1];
//             if (rowStyle) {
//               data.cell.styles = { ...data.cell.styles, ...rowStyle };
//             }
//           }
//         },
//       });

//       doc.save("retailer-list.pdf");
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting PDF:", error);
//       toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
//     }
//   };

//   const handleprint = (id, retailer_id) => {
//     navigate(`/retailer-bill/${retailer_id}`);
//   };

//   const copyToClipboard = () => {
//     try {
//       const headers = [
//         "S.No",
//         "Retailer ID",
//         "Retailer Date",
//         "Retailer Name",
//         "Total Items",
//       ];
//       const rows = filteredData.map((item, index) => [
//         index + 1,
//         item.retailer_id || "",
//         formatDate(item.retailer_date) || "",
//         item.supplier_id || "",
//         item.items?.length || "",
//       ]);

//       const formattedText = [headers, ...rows]
//         .map((row) => row.map((field) => `"${field}"`).join("\t"))
//         .join("\n");

//       if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard
//           .writeText(formattedText)
//           .then(() => {
//             toast.success("Data copied to clipboard!", 3000, "topRight");
//           })
//           .catch((err) => {
//             console.error("Clipboard API failed:", err);
//             fallbackCopy(formattedText);
//           });
//       } else {
//         fallbackCopy(formattedText);
//       }
//     } catch (error) {
//       console.error("Unexpected error copying to clipboard:", error);
//       toast.error("Error copying data. Please try again.", 3000, "topRight");
//     }
//   };

//   const fallbackCopy = (text) => {
//     try {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "fixed";
//       textArea.style.top = 0;
//       textArea.style.left = 0;
//       textArea.style.width = "2em";
//       textArea.style.height = "2em";
//       textArea.style.padding = 0;
//       textArea.style.border = "none";
//       textArea.style.outline = "none";
//       textArea.style.boxShadow = "none";
//       textArea.style.background = "transparent";
//       document.body.appendChild(textArea);
//       textArea.focus();
//       textArea.select();
//       const successful = document.execCommand("copy");
//       document.body.removeChild(textArea);
//       if (successful) {
//         toast.success("Data copied to clipboard!", 3000, "topRight");
//       } else {
//         toast.error("Failed to copy data", 3000, "topRight");
//       }
//     } catch (err) {
//       console.error("Fallback copy failed:", err);
//       toast.error("Failed to copy data", 3000, "topRight");
//     }
//   };

//   const exportCSV = () => {
//     try {
//       const csvData = [
//         [
//           "S.No",
//           "Retailer ID",
//           "Retailer Date",
//           "Retailer Name",
//           "Total Items",
//         ],
//         ...filteredData.map((item, index) => [
//           index + 1,
//           item.retailer_id || "",
//           formatDate(item.retailer_date) || "",
//           item.supplier_id || "",
//           item.items?.length || "",
//         ]),
//       ];

//       const csvContent = csvData
//         .map((row) => row.map((field) => `"${field}"`).join(","))
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute("download", "retailer-list.csv");
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success("CSV exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
//     }
//   };

//   const exportExcel = () => {
//     try {
//       const excelData = filteredData.map((item, index) => ({
//         "S.No": index + 1,
//         "Retailer ID": item.retailer_id || "",
//         "Retailer Date": formatDate(item.retailer_date) || "",
//         "Retailer Name": item.supplier_id || "",
//         "Total Items": item.items?.length || "",
//       }));

//       const ws = XLSX.utils.json_to_sheet(excelData);
//       const wb = XLSX.utils.book_new();
//       const colWidths = [
//         { wch: 8 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 15 },
//       ];
//       ws["!cols"] = colWidths;
//       XLSX.utils.book_append_sheet(wb, ws, "Retailers");
//       XLSX.writeFile(wb, "retailer-list.xlsx");
//       toast.success("Excel file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error);
//       toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
//     }
//   };

//   // Added Retailers List Functions
//   const handleListOpenModal = (id, retailer_id) => {
//     setListDeleteid(id);
//     setListDeletename(retailer_id);
//     setListDeleteShowModals(true);
//   };

//   const handleListCloseModal = () => {
//     setListDeleteShowModals(false);
//     setListDeleteid("");
//     setListDeletename("");
//   };

//   const handleListDelete = () => {
//     try {
//       const updatedRetailers = addedRetailers.filter(
//         (retailer) => retailer.id !== listGetdeleteid
//       );
//       setAddedRetailers(updatedRetailers);
//       localStorage.setItem("addedRetailers", JSON.stringify(updatedRetailers));
//       toast.success("Retailer deleted successfully!", 3000, "topRight");
//       handleListCloseModal();
//     } catch (error) {
//       console.error("Error deleting retailer:", error);
//       toast.error("Failed to delete retailer", 3000, "topRight");
//     }
//   };

//   const handleListPrint = () => {
//     try {
//       const printWindow = window.open("", "_blank");
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Added Retailers List</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//               th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//               th { background-color: #f2f2f2; font-weight: bold; }
//               .header { text-align: center; margin-bottom: 20px; }
//             </style>
//           </head>
//           <body>
//             <div class="header"><h2>Added Retailers List</h2></div>
//             <table>
//               <thead>
//                 <tr>
//                   <th>S.No</th>
//                   <th>Retailer ID</th>
//                   <th>Name</th>
//                   <th>Mobile</th>
//                   <th>Address</th>
//                   <th>Status</th>
//                   <th>Date Added</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${listFilteredData
//                   .map((item, index) => `
//                     <tr>
//                       <td>${index + 1}</td>
//                       <td>${item.retailer_id}</td>
//                       <td>${item.name}</td>
//                       <td>${item.mobile}</td>
//                       <td>${item.address}</td>
//                       <td>${item.status}</td>
//                       <td>${formatDate(item.retailer_date)}</td>
//                     </tr>
//                   `)
//                   .join("")}
//               </tbody>
//             </table>
//           </body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//       toast.success("Print dialog opened!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error printing:", error);
//       toast.error("Error printing. Please try again", 3000, "topRight");
//     }
//   };

//   const exportListPDF = () => {
//     try {
//       const doc = new jsPDF();
//       doc.setFontSize(20);
//       doc.text("Added Retailers List", 14, 22);
//       doc.setFontSize(12);
//       doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

//       const tableColumn = ["S.No", "Retailer ID", "Name", "Mobile", "Address", "Status", "Date Added"];
//       const tableRows = listFilteredData.map((item, index) => [
//         index + 1,
//         item.retailer_id,
//         item.name,
//         item.mobile,
//         item.address,
//         item.status,
//         formatDate(item.retailer_date),
//       ]);

//       autoTable(doc, {
//         head: [tableColumn],
//         body: tableRows,
//         startY: 45,
//         styles: { fontSize: 8, cellPadding: 2 },
//         headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//       });

//       doc.save("added-retailers.pdf");
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting PDF:", error);
//       toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
//     }
//   };

//   const copyListToClipboard = () => {
//     try {
//       const text = listFilteredData
//         .map(
//           (item, index) =>
//             `${index + 1}\t${item.retailer_id}\t${item.name}\t${item.mobile}\t${item.address}\t${item.status}\t${formatDate(item.retailer_date)}`
//         )
//         .join("\n");
//       const header = "S.No\tRetailer ID\tName\tMobile\tAddress\tStatus\tDate Added\n";
//       const fullText = header + text;

//       if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard
//           .writeText(fullText)
//           .then(() => toast.success("Copied to clipboard!", 3000, "topRight"))
//           .catch(() => fallbackCopy(fullText));
//       } else {
//         fallbackCopy(fullText);
//       }
//     } catch (error) {
//       console.error("Error copying to clipboard:", error);
//       toast.error("Error copying data. Please try again.", 3000, "topRight");
//     }
//   };

//   const exportListCSV = () => {
//     try {
//       const csvData = listFilteredData.map((item) => ({
//         "Retailer ID": item.retailer_id,
//         Name: item.name,
//         Mobile: item.mobile,
//         Address: item.address,
//         Status: item.status,
//         "Date Added": formatDate(item.retailer_date),
//       }));
//       const worksheet = XLSX.utils.json_to_sheet(csvData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Retailers");
//       XLSX.writeFile(workbook, "added-retailers.csv");
//       toast.success("CSV exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
//     }
//   };

//   const exportListExcel = () => {
//     try {
//       const excelData = listFilteredData.map((item) => ({
//         "Retailer ID": item.retailer_id,
//         Name: item.name,
//         Mobile: item.mobile,
//         Address: item.address,
//         Status: item.status,
//         "Date Added": formatDate(item.retailer_date),
//       }));
//       const worksheet = XLSX.utils.json_to_sheet(excelData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Retailers");
//       XLSX.writeFile(workbook, "added-retailers.xlsx");
//       toast.success("Excel file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error);
//       toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
//     }
//   };

//   const fieldsToSearch = ['retailer_id', 'retailer_date', 'supplier_id', 'pure', 'amount', 'close'];

//   const filteredData = responseData.filter((item) => {
//     const searchLower = searchTerm.trim().toLowerCase();
//     return fieldsToSearch.some(
//       (field) => item[field]?.toLowerCase().includes(searchLower)
//     );
//   });

//   const listFieldsToSearch = ["retailer_id", "name", "mobile", "address", "status"];

//   const listFilteredData = addedRetailers.filter((item) => {
//     const searchLower = listSearchTerm.trim().toLowerCase();
//     return listFieldsToSearch.some((field) =>
//       item[field]?.toLowerCase().includes(searchLower)
//     );
//   });

//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const listTotalItems = listFilteredData.length;
//   const listTotalPages = listShowAllItems ? 1 : Math.ceil(listTotalItems / listItemsPerPage);
//   const listCurrentItems = listShowAllItems
//     ? listFilteredData
//     : listFilteredData.slice(
//         (listCurrentPage - 1) * listItemsPerPage,
//         listCurrentPage * listItemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1);
//     }
//   };

//   const handleListPageChange = (page) => {
//     if (page < 1 || page > listTotalPages) return;
//     setListCurrentPage(page);
//   };

//   const handleListItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setListShowAllItems(true);
//       setListCurrentPage(1);
//     } else {
//       setListShowAllItems(false);
//       setListItemsPerPage(Number(value));
//       setListCurrentPage(1);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   const renderListPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
//     let startPage = Math.max(1, listCurrentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(listTotalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${listCurrentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handleListPageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }
//     return pages;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return dateString;
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return dateString;
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchNotifications();
//     const interval = setInterval(() => {
//       fetchData();
//       fetchNotifications();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid mb-5">
//         <div className="d-flex mb-2 justify-content-between align-items-center">
//           <div className="d-flex">
//             <h6 className="card-title m-2">Retailer</h6>
//             <button
//               className="btn btn-primary btn-sm rounded-3"
//               onClick={() => navigate("/add-retailer")}
//             >
//               Add <span className="ms-2">+</span>
//             </button>
//           </div>

//           <div className="d-flex gap-2">
//             <button
//               className="btn btn-success btn-sm rounded-3"
//               onClick={openAddRetailerModal}
//             >
//               Add New Retailer <span className="ms-2">+</span>
//             </button>
//             <button
//               className="btn btn-info btn-sm text-white rounded-3"
//               onClick={() => setShowAddedRetailersPopup(true)}
//             >
//               List Added Retailers ({addedRetailers.length})
//             </button>
//           </div>
//         </div>

//         {/* Add Retailer Modal */}
//         <div
//           className={`modal fade ${showAddRetailerModal ? "show" : ""}`}
//           style={{
//             display: showAddRetailerModal ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//           onClick={() => setShowAddRetailerModal(false)}
//         >
//           <div 
//             className="modal-dialog modal-dialog-centered" 
//             style={{ maxWidth: '500px' }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Add New Retailer</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowAddRetailerModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="mb-3">
//                   <label className="form-label">Retailer ID</label>
//                   <input
//                     type="text"
//                     className="form-control bg-light"
//                     value={newRetailerId}
//                     disabled
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Name <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
//                     placeholder="Enter Name"
//                     value={addData.name}
//                     onChange={(e) => setAddData({ ...addData, name: e.target.value })}
//                   />
//                   {formErrors.name && (
//                     <div className="invalid-feedback">{formErrors.name}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Mobile Number <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     inputMode="numeric"
//                     maxLength="10"
//                     className={`form-control ${formErrors.mobile ? "is-invalid" : ""}`}
//                     placeholder="Enter 10-digit Mobile"
//                     value={addData.mobile}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d{0,10}$/.test(value)) {
//                         setAddData({ ...addData, mobile: value });
//                       }
//                     }}
//                   />
//                   {formErrors.mobile && (
//                     <div className="invalid-feedback">{formErrors.mobile}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Address <span className="text-danger">*</span>
//                   </label>
//                   <textarea
//                     className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
//                     placeholder="Enter Address"
//                     rows="2"
//                     value={addData.address}
//                     onChange={(e) => setAddData({ ...addData, address: e.target.value })}
//                   />
//                   {formErrors.address && (
//                     <div className="invalid-feedback">{formErrors.address}</div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">
//                     Status <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select ${formErrors.status ? "is-invalid" : ""}`}
//                     value={addData.status}
//                     onChange={(e) => setAddData({ ...addData, status: e.target.value })}
//                   >
//                     <option value="">Select Status</option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                   {formErrors.status && (
//                     <div className="invalid-feedback">{formErrors.status}</div>
//                   )}
//                 </div>

//                 <div className="d-flex gap-2 justify-content-end mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={() => setShowAddRetailerModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button 
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={handleAddRetailerSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Added Retailers List Popup Modal */}
//         {showAddedRetailersPopup && (
//           <>
//             <div
//               className="modal fade show"
//               style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }}
//               tabIndex="-1"
//             >
//               <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
//                 <div className="modal-content">
//                   <div className="modal-header bg-primary text-white">
//                     <h5 className="modal-title">Added Retailers List ({addedRetailers.length})</h5>
//                     <button
//                       type="button"
//                       className="btn-close btn-close-white"
//                       onClick={() => setShowAddedRetailersPopup(false)}
//                     ></button>
//                   </div>
//                   <div className="modal-body p-0">
//                     {/* Export Buttons */}
//                     <div className="d-flex justify-content-center p-3 bg-light border-bottom">
//                       <button className="btn btn-sm btn-info text-white mx-1" onClick={handleListPrint}>Print</button>
//                       <button className="btn btn-sm btn-info text-white mx-1" onClick={exportListPDF}>PDF</button>
//                       <button className="btn btn-sm btn-info text-white mx-1" onClick={copyListToClipboard}>Copy</button>
//                       <button className="btn btn-sm btn-info text-white mx-1" onClick={exportListCSV}>CSV</button>
//                       <button className="btn btn-sm btn-info text-white mx-1" onClick={exportListExcel}>Excel</button>
//                     </div>

//                     {/* Search and Items Per Page */}
//                     <div className="p-3 border-bottom">
//                       <div className="row align-items-center">
//                         <div className="col-md-6 mb-2 mb-md-0">
//                           <div className="d-flex align-items-center">
//                             <label className="form-label text-dark mb-0 me-2">Show:</label>
//                             <select
//                               className="form-control form-control-sm"
//                               onChange={handleListItemsPerPageChange}
//                               value={listShowAllItems ? "All" : listItemsPerPage}
//                             >
//                               <option value="All">All</option>
//                               {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                                 <option key={pageSize} value={pageSize}>
//                                   {pageSize}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="input-group">
//                             <input
//                               type="text"
//                               className="form-control form-control-sm"
//                               placeholder="Search retailers..."
//                               value={listSearchTerm}
//                               onChange={(e) => {
//                                 setListSearchTerm(e.target.value);
//                                 setListCurrentPage(1);
//                               }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Table */}
//                     <div className="table-responsive">
//                       <table className="table table-striped mb-0">
//                         <thead className="table-dark">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Retailer ID</th>
//                             <th>Name</th>
//                             <th>Mobile</th>
//                             <th>Address</th>
//                             <th>Status</th>
//                             <th>Date Added</th>
//                             <th>Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {listCurrentItems.length > 0 ? (
//                             listCurrentItems.map((item, index) => (
//                               <tr key={item.id}>
//                                 <td>{(listCurrentPage - 1) * listItemsPerPage + index + 1}</td>
//                                 <td>{item.retailer_id}</td>
//                                 <td>{item.name}</td>
//                                 <td>{item.mobile}</td>
//                                 <td>{item.address}</td>
//                                 <td>
//                                   <span className={`badge ${item.status === "Active" ? "bg-success" : "bg-secondary"}`}>
//                                     {item.status}
//                                   </span>
//                                 </td>
//                                 <td>{formatDate(item.retailer_date)}</td>
//                                 <td>
//                                   <button
//                                     className="btn btn-sm btn-light"
//                                     onClick={() => handleListOpenModal(item.id, item.retailer_id)}
//                                   >
//                                     <i className="fa-solid fa-trash text-danger fs-6"></i>
//                                   </button>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="8" className="text-center py-4">
//                                 No added retailers found
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>

//                     {/* Pagination */}
//                     {!listShowAllItems && listTotalPages > 1 && (
//                       <div className="p-3 border-top">
//                         <div className="row align-items-center">
//                           <div className="col-md-6 mb-2 mb-md-0">
//                             <p className="text-muted mb-0">
//                               Showing {(listCurrentPage - 1) * listItemsPerPage + 1} to{" "}
//                               {Math.min(listCurrentPage * listItemsPerPage, listTotalItems)} of {listTotalItems} entries
//                             </p>
//                           </div>
//                           <div className="col-md-6">
//                             <nav aria-label="Page navigation">
//                               <ul className="pagination justify-content-end mb-0">
//                                 <li className={`page-item ${listCurrentPage === 1 ? "disabled" : ""}`}>
//                                   <button className="page-link" onClick={() => handleListPageChange(1)}>First</button>
//                                 </li>
//                                 <li className={`page-item ${listCurrentPage === 1 ? "disabled" : ""}`}>
//                                   <button className="page-link" onClick={() => handleListPageChange(listCurrentPage - 1)}>Previous</button>
//                                 </li>
//                                 {renderListPageNumbers()}
//                                 <li className={`page-item ${listCurrentPage === listTotalPages ? "disabled" : ""}`}>
//                                   <button className="page-link" onClick={() => handleListPageChange(listCurrentPage + 1)}>Next</button>
//                                 </li>
//                                 <li className={`page-item ${listCurrentPage === listTotalPages ? "disabled" : ""}`}>
//                                   <button className="page-link" onClick={() => handleListPageChange(listTotalPages)}>Last</button>
//                                 </li>
//                               </ul>
//                             </nav>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                   <div className="modal-footer">
//                     <button
//                       className="btn btn-secondary"
//                       onClick={() => setShowAddedRetailersPopup(false)}
//                     >
//                       Close
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-backdrop fade show"></div>
//           </>
//         )}

//         {/* List Delete Confirmation Modal */}
//         <div
//           className={`modal fade ${listDeleteShowModals ? "show" : ""}`}
//           style={{
//             display: listDeleteShowModals ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-dialog-centered modal-confirm">
//             <div className="modal-content">
//               <div className="modal-body text-center">
//                 <div className="d-flex justify-content-center mb-3">
//                   <div
//                     className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
//                     style={{ width: "80px", height: "80px", margin: "0 auto" }}
//                   >
//                     <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                   </div>
//                 </div>
//                 <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
//                 <h6 className="mb-4 text-center">
//                   Do you really want to delete this
//                   <span className="text-primary"> ({listGetdeletename})</span>?
//                 </h6>
//                 <div className="d-flex btn-group">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm flex-grow-1"
//                     onClick={handleListCloseModal}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                     onClick={handleListDelete}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card shadow-sm">
//           <div className="card-body">
//             <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
//               <div className="d-flex">
//                 <label className="form-label text-dark mt-2">Show : </label>
//                 <div>
//                   <select
//                     className="form-control mx-2"
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>

//               <div className="search-container">
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search"
//                     aria-label="Search"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="card tableCard p-2">
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="bg-light">
//                     <tr>
//                       <th scope="col">S.No</th>
//                       <th scope="col">Retailer ID</th>
//                       <th scope="col">Retailer Date</th>
//                       <th scope="col">Retailer Name</th>
//                       <th scope="col">Total Items</th>
//                       <th scope="col">Total Pure</th>
//                       <th scope="col">Total Amount</th>
//                       <th scope="col">Balance</th>
//                       <th scope="col">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((item, index) => {
//                         const userId = localStorage.getItem("username");
//                         const notification = notifications.find(
//                           (notif) =>
//                             notif.table_id === item.id.toString() &&
//                             notif.viewed === "false"
//                         );
//                         let rowClass = "";
//                         if (notification) {
//                           switch (notification.status) {
//                             case "accepted":
//                               rowClass = "table-secondary";
//                               break;
//                             case "rejected":
//                               rowClass = "table-danger";
//                               break;
//                             case "requested":
//                               rowClass = "table-info";
//                               break;
//                           }
//                         }
//                         return (
//                           <tr key={item.id} className={rowClass}>
//                             <td>{index + 1}</td>
//                             <td>{item.retailer_id}</td>
//                             <td>{formatDate(item.retailer_date)}</td>
//                             <td>{item.supplier_id}</td>
//                             <td>{item.items?.length}</td>
//                             <td>{item.pure || "-"}</td>
//                             <td>{item.amount || "-"}</td>
//                             <td>{item.close}</td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleUpdateRetailer(item.id)}
//                               >
//                                 <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light"
//                                 onClick={() =>
//                                   handleOpenModal(item.id, item.retailer_id)
//                                 }
//                               >
//                                 <i className="fa-solid fa-trash text-danger fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light"
//                                 onClick={() =>
//                                   handleprint(item.id, item.retailer_id)
//                                 }
//                               >
//                                 <i className="fa-solid fa-print text-secondary fs-6"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan="9" className="text-center">
//                           No retailers found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="row">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First"
//                         >
//                           <span aria-hidden="true">««</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">«</span>
//                         </button>
//                       </li>
//                       {renderPageNumbers()}
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">»</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last"
//                         >
//                           <span aria-hidden="true">»»</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//    {/* Notification Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="notificationModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="notificationModalLabel"
//               >
//                 Send {actionType} Request to Admin
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closeNotificationModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div>
//                 <p className="text-center">
//                   Do you want to request to {actionType.toLowerCase()} this
//                   retailer?
//                 </p>
//                 <div className="text-center mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm px-4 me-2"
//                     onClick={closeNotificationModal}
//                   >
//                     No
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={isSubmitting}
//                     onClick={handleNotificationSubmit}
//                   >
//                     Yes
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModals ? "show" : ""}`}
//         style={{
//           display: deleteShowModals ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
//                   style={{ width: "80px", height: "80px", margin: "0 auto" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>
//               <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
//               <h6 className="mb-4 text-center">
//                 Do you really want to delete this
//                 <span className="text-primary"> ({getdeletename})</span>?
//               </h6>
//               <div className="d-flex btn-group">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm flex-grow-1"
//                   onClick={handleCloseModal}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {(showModal || deleteShowModals || showAddRetailerModal) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </>
//   );
// }

// export default Retailer;


import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function Retailer() {
  const navigate = useNavigate();
  const toast = useToast();
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showViewRetailersModal, setShowViewRetailersModal] = useState(false);
  const [retailerDetails, setRetailerDetails] = useState([]);

  // Add Retailer Modal States
  const [showAddRetailerModal, setShowAddRetailerModal] = useState(false);
  const [newRetailerId, setNewRetailerId] = useState("");
  const [addData, setAddData] = useState({
    name: "",
    mobile: "",
    address: "",
    status: ""
  });
  const [formErrors, setFormErrors] = useState({});

  // Edit Retailer Modal States
  const [showEditRetailerModal, setShowEditRetailerModal] = useState(false);
  const [editRetailerId, setEditRetailerId] = useState("");
  const [editData, setEditData] = useState({
    name: "",
    mobile: "",
    address: "",
    status: ""
  });
  const [editFormErrors, setEditFormErrors] = useState({});

  // Edit Retailer: open modal pre-filled with existing data
  const openEditRetailerModal = (retailer) => {
    setEditRetailerId(retailer.retailer_id);
    setEditData({
      name: retailer.name || "",
      mobile: retailer.mobile || "",
      address: retailer.address || "",
      status: retailer.status || "Active"
    });
    setEditFormErrors({});
    setShowEditRetailerModal(true);
  };

  const handleEditRetailerSubmit = async () => {
    setEditFormErrors({});
    const errors = {};
    if (!editData.name.trim()) errors.name = "Name is required";
    if (!editData.mobile.trim()) errors.mobile = "Mobile is required";
    if (!/^\d{10}$/.test(editData.mobile)) errors.mobile = "Mobile must be 10 digits";
    if (!editData.address.trim()) errors.address = "Address is required";
    if (!editData.status) errors.status = "Status is required";

    if (Object.keys(errors).length > 0) {
      setEditFormErrors(errors);
      return;
    }

    try {
      setLoading(true);
      const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");
      const payload = {
        retailer_id: editRetailerId,
        name: editData.name,
        mobile: editData.mobile,
        address: editData.address,
        status: editData.status,
        updated_by: localStorage.getItem("username") || "admin",
        updated_date: currentDateTime,
      };

      const response = await axios.put(`${ApiUrl}/Api/retailer.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data?.status === false) {
        throw new Error(response.data?.message || "Failed to update retailer");
      }

      toast.success("Retailer updated successfully!", 3000, "topRight");
      setShowEditRetailerModal(false);
      fetchData();
      fetchRetailerDetails();
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update retailer";
      toast.error(errorMessage, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Generate Retailer ID and open modal
  const openAddRetailerModal = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/retailer.php/generate-retailer-code`);
      const newId = response.data?.retailer_id || "RET-001";
      setNewRetailerId(newId);
      setAddData({ name: "", mobile: "", address: "", status: "" });
      setFormErrors({});
      setShowAddRetailerModal(true);
    } catch (error) {
      console.error("Error generating retailer ID:", error);
      toast.error("Failed to generate retailer ID", 3000, "topRight");
    }
  };

  // Handle form submission
  const handleAddRetailerSubmit = async () => {
    setFormErrors({});

    // Validation
    const errors = {};
    if (!addData.name.trim()) errors.name = "Name is required";
    if (!addData.mobile.trim()) errors.mobile = "Mobile is required";
    if (addData.mobile.length !== 10) errors.mobile = "Mobile must be 10 digits";
    if (!addData.address.trim()) errors.address = "Address is required";
    if (!addData.status) errors.status = "Status is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      setLoading(true);

      const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");
      const payload = {
        retailer_id: newRetailerId,
        name: addData.name,
        mobile: addData.mobile,
        address: addData.address,
        status: addData.status,
        created_by: localStorage.getItem("username") || "admin",
        created_date: currentDateTime,
      };

      console.log("Sending retailer data:", payload);

      const addResponse = await axios.post(`${ApiUrl}/Api/retailer.php`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("Add retailer response:", addResponse.data);

      if (addResponse.data?.status === false) {
        throw new Error(addResponse.data?.message || "Failed to add retailer");
      }

      toast.success("Retailer added successfully!", 3000, "topRight");

      // Reset form and close modal
      setAddData({ name: "", mobile: "", address: "", status: "" });
      setShowAddRetailerModal(false);

      // Refresh data
      fetchData();
      setCurrentPage(1);
      setSearchTerm("");
    } catch (error) {
      console.error("Error adding retailer:", error);
      console.error("Error response:", error.response?.data);

      const errorMessage = error.response?.data?.message ||
        error.message ||
        "Failed to add retailer";
      toast.error(errorMessage, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const fetchRetailerDetails = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/retailer.php`); // Adjust endpoint if needed
      // Assuming this returns array of retailers with name, mobile, address, status, etc.
      const data = response.data?.data || response.data || [];
      setRetailerDetails(data);
      setShowViewRetailersModal(true);
    } catch (error) {
      console.error("Error fetching retailer details:", error);
      toast.error("Failed to load retailer details", 3000, "topRight");
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
      const reversedData = (response.data?.data || []).slice().reverse();
      setResponseData(reversedData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
    }
  };

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error("Failed to fetch notifications", 3000, "topRight");
    }
  };

  const checkNotificationStatus = (retailerId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === retailerId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (retailerId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === retailerId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const openNotificationModal = (id, action) => {
    setSelectedRetailerId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedRetailerId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedRetailerId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "retailer_details",
        table_id: selectedRetailerId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        "Error submitting notification. Please try again.",
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdateRetailer = (id) => {
    const userRole = localStorage.getItem("role");
    const retailer = responseData.find((item) => item.id === id);

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(`update-retailer/${id}`);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      navigate(`update-retailer/${id}`);
    }
  };

  const handleOpenModal = (id, retailer_id) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Delete")) {
        setdeleteid(id);
        setdeletename(retailer_id);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setdeleteid(id);
      setdeletename(retailer_id);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setdeleteid("");
    setdeletename("");
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(`${ApiUrl}/Api/retailer_details.php/${getdeleteid}`);

      const notification = notifications.find(
        (notif) =>
          notif.table_id === getdeleteid.toString() &&
          notif.button_value === "Delete" &&
          notif.viewed === "false"
      );
      if (notification) {
        const currentTime = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const notificationPayload = {
          id: notification.id,
          viewed: "true",
          updated_by: localStorage.getItem("username"),
          updated_date: currentTime,
          table_name: notification.table_name,
          table_id: notification.table_id,
          employe_id: notification.employe_id,
          status: notification.status,
          button_value: notification.button_value,
          time: notification.time,
          created_date: notification.created_date,
        };

        await axios.put(
          `${ApiUrl}/Api/notification.php/${notification.id}`,
          notificationPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
      }

      toast.success("Retailer deleted successfully!", 3000, "topRight");
      handleCloseModal();
      fetchData();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Failed to delete data", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Retailer List</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; font-weight: bold; }
              .header { text-align: center; margin-bottom: 20px; }
              .table-secondary { background-color: #e2e3e5; }
              .table-danger { background-color: #f8d7da; }
              .table-info { background-color: #cff4fc; }
            </style>
          </head>
          <body>
            <div class="header"><h2>Retailer List</h2></div>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Retailer ID</th>
                  <th>Retailer Date</th>
                  <th>Retailer Name</th>
                  <th>Total Items</th>
                </tr>
              </thead>
              <tbody>
                ${filteredData
          .map((item, index) => {
            const userId = localStorage.getItem("username");
            const notification = notifications.find(
              (notif) =>
                notif.table_id === item.id.toString() &&
                notif.employe_id === userId &&
                notif.viewed === "false"
            );
            let rowClass = "";
            if (notification) {
              switch (notification.status) {
                case "accepted":
                  rowClass = "table-secondary";
                  break;
                case "rejected":
                  rowClass = "table-danger";
                  break;
                case "requested":
                  rowClass = "table-info";
                  break;
              }
            }
            return `
                      <tr class="${rowClass}">
                        <td>${index + 1}</td>
                        <td>${item.retailer_id || ""}</td>
                        <td>${formatDate(item.retailer_date) || ""}</td>
                        <td>${item.retailer_details?.name || item.supplier_details?.name || ""}</td>
                        <td>${item.items?.length || ""}</td>
                      </tr>
                    `;
          })
          .join("")}
              </tbody>
            </table>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 3000, "topRight");
    }
  };

  const handleViewPrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>All Retailers Details</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h2 { text-align: center; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 10px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            @media print {
              body { margin: 10mm; }
            }
          </style>
        </head>
        <body>
          <h2>All Retailers Details</h2>
          <p>Generated on: ${new Date().toLocaleString()}</p>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Retailer ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Address</th>
                <th>Status</th>
                <th>Created Date</th>
              </tr>
            </thead>
            <tbody>
              ${retailerDetails
          .map((retailer, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${retailer.retailer_id || "-"}</td>
                    <td>${retailer.name || "-"}</td>
                    <td>${retailer.mobile || "-"}</td>
                    <td>${retailer.address || "-"}</td>
                    <td>
                      <span class="badge ${retailer.status === 'Active' ? 'bg-success' : 'bg-secondary'}">
                        ${retailer.status || "-"}
                      </span>
                    </td>
                    <td>${formatDate(retailer.created_date) || "-"}</td>
                  </tr>
                `)
          .join("")}
            </tbody>
          </table>
        </body>
      </html>
    `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print opened successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Print error:", error);
      toast.error("Failed to print", 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text("Retailer List", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

      const tableColumn = [
        "S.No",
        "Retailer No",
        "Retailer ID",
        "Retailer Date",
        "Retailer Name",
        "Items",
        "Return Type",
        "Opening (g)",
        "Current (g)",
        "Total Pure (g)",
        "Returned",
        "Closing (g)",
      ];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false"
        );
        let rowStyle = "";
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          item.retailer_id || "",
          item.supplier_id || "",
          formatDate(item.retailer_date) || "",
          item.retailer_details?.name || item.supplier_details?.name || "",
          item.items?.length || "",
          item.return_type || "-",
          parseFloat(item.opening || 0).toFixed(3),
          parseFloat(item.current || 0).toFixed(3),
          parseFloat(item.total_pure || 0).toFixed(3),
          item.return_type === "Pure"
            ? `${parseFloat(item.pure || 0).toFixed(3)} g`
            : item.return_type === "Amount"
            ? `₹${parseFloat(item.amount || 0).toFixed(2)}`
            : "-",
          parseFloat(item.close || 0).toFixed(3),
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 25 },
          3: { cellWidth: 30 },
          4: { cellWidth: 20 },
        },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save("retailer-list.pdf");
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Error exporting PDF. Please try again.", 3000, "topRight");
    }
  };


  const exportViewRetailersPDF = () => {
    try {
      const doc = new jsPDF('l', 'mm', 'a4'); // Landscape mode for wider table
      doc.setFontSize(18);
      doc.text("All Retailers Details", 14, 20);
      doc.setFontSize(11);
      doc.text(`Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`, 14, 30);

      const tableColumn = ["S.No", "Retailer ID", "Name", "Mobile", "Address", "Status", "Created Date"];
      const tableRows = retailerDetails.map((retailer, index) => [
        index + 1,
        retailer.retailer_id || "-",
        retailer.name || "-",
        retailer.mobile || "-",
        retailer.address || "-",
        retailer.status || "Inactive",
        formatDate(retailer.created_date) || "-",
      ]);

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 40,
        styles: { fontSize: 9, cellPadding: 3 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [245, 249, 251] },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 30 },
          2: { cellWidth: 40 },
          3: { cellWidth: 30 },
          4: { cellWidth: 60 },
          5: { cellWidth: 20 },
          6: { cellWidth: 30 },
        },
        didParseCell: (data) => {
          if (data.column.index === 5) { // Status column
            if (data.cell.text[0] === "Active") {
              data.cell.styles.textColor = [0, 128, 0];
              data.cell.styles.fontStyle = 'bold';
            } else {
              data.cell.styles.textColor = [100, 100, 100];
            }
          }
        }
      });

      doc.save("all-retailers-details.pdf");
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting View Retailers PDF:", error);
      toast.error("Failed to export PDF", 3000, "topRight");
    }
  };

  const handleprint = (id, retailer_id) => {
    navigate(`/retailer-bill/${retailer_id}`);
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Retailer No",
        "Retailer ID",
        "Retailer Date",
        "Retailer Name",
        "Total Items",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.retailer_id || "",
        item.supplier_id || "",
        formatDate(item.retailer_date) || "",
        item.retailer_details?.name || item.supplier_details?.name || "",
        item.items?.length || "",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success("Data copied to clipboard!", 3000, "topRight");
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Error copying data. Please try again.", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied to clipboard!", 3000, "topRight");
      } else {
        toast.error("Failed to copy data", 3000, "topRight");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        [
          "S.No",
          "Retailer No",
          "Retailer ID",
          "Retailer Date",
          "Retailer Name",
          "Total Items",
        ],
        ...filteredData.map((item, index) => [
          index + 1,
          item.retailer_id || "",
          item.supplier_id || "",
          formatDate(item.retailer_date) || "",
          item.retailer_details?.name || item.supplier_details?.name || "",
          item.items?.length || "",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "retailer-list.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Error exporting CSV. Please try again.", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        "Retailer No": item.retailer_id || "",
        "Retailer ID": item.supplier_id || "",
        "Retailer Date": formatDate(item.retailer_date) || "",
        "Retailer Name": item.retailer_details?.name || item.supplier_details?.name || "",
        "Total Items": item.items?.length || "",
        "Return Type": item.return_type || "",
        "Opening (g)": parseFloat(item.opening || 0).toFixed(3),
        "Current (g)": parseFloat(item.current || 0).toFixed(3),
        "Total Pure (g)": parseFloat(item.total_pure || 0).toFixed(3),
        "Returned": item.return_type === "Pure"
          ? `${parseFloat(item.pure || 0).toFixed(3)} g`
          : item.return_type === "Amount"
          ? `₹${parseFloat(item.amount || 0).toFixed(2)}`
          : "-",
        "Closing (g)": parseFloat(item.close || 0).toFixed(3),
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      const colWidths = [
        { wch: 8 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 15 },
      ];
      ws["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(wb, ws, "Retailers");
      XLSX.writeFile(wb, "retailer-list.xlsx");
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Error exporting Excel. Please try again.", 3000, "topRight");
    }
  };

  const fieldsToSearch = ['retailer_id', 'retailer_date', 'return_type', 'opening', 'current', 'total_pure', 'pure', 'amount', 'close'];

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.trim().toLowerCase();
    return fieldsToSearch.some(
      (field) => item[field]?.toLowerCase().includes(searchLower)
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid mb-5">
        <div className="d-flex mb-2 justify-content-between align-items-center">
          <div className="d-flex">
            <h6 className="card-title m-2">Retailer</h6>
            <button
              className="btn btn-primary btn-sm rounded-3"
              onClick={() => navigate("/add-retailer")}
            >
              Add <span className="ms-2">+</span>
            </button>
          </div>

          <div className="d-flex gap-2">
            <button
              className="btn btn-success btn-sm rounded-3"
              onClick={openAddRetailerModal}
            >
              Add Retailer <span className="ms-2">+</span>
            </button>

            <button
              className="btn btn-info btn-sm rounded-3 text-white"
              onClick={fetchRetailerDetails}
            >
              View Retailers <i className="fa-solid fa-eye ms-2"></i>
            </button>
          </div>

        </div>

        {/* Add Retailer Modal */}
        <div
          className={`modal fade ${showAddRetailerModal ? "show" : ""}`}
          style={{
            display: showAddRetailerModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          onClick={() => setShowAddRetailerModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: '500px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Retailer</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAddRetailerModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Retailer ID</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={newRetailerId}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
                    placeholder="Enter Name"
                    value={addData.name}
                    onChange={(e) => setAddData({ ...addData, name: e.target.value })}
                  />
                  {formErrors.name && (
                    <div className="invalid-feedback">{formErrors.name}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="10"
                    className={`form-control ${formErrors.mobile ? "is-invalid" : ""}`}
                    placeholder="Enter 10-digit Mobile"
                    value={addData.mobile}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setAddData({ ...addData, mobile: value });
                      }
                    }}
                  />
                  {formErrors.mobile && (
                    <div className="invalid-feedback">{formErrors.mobile}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
                    placeholder="Enter Address"
                    rows="2"
                    value={addData.address}
                    onChange={(e) => setAddData({ ...addData, address: e.target.value })}
                  />
                  {formErrors.address && (
                    <div className="invalid-feedback">{formErrors.address}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${formErrors.status ? "is-invalid" : ""}`}
                    value={addData.status}
                    onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {formErrors.status && (
                    <div className="invalid-feedback">{formErrors.status}</div>
                  )}
                </div>

                <div className="d-flex gap-2 justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowAddRetailerModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAddRetailerSubmit}
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card tableCard p-2">
              <div className="table-responsive">
                <table className="table">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Retailer No</th>
                      <th scope="col">Retailer ID</th>
                      <th scope="col">Retailer Date</th>
                      <th scope="col">Retailer Name</th>
                      <th scope="col">Total Items</th>
                      <th scope="col">Return Type</th>
                      <th scope="col">Opening (g)</th>
                      <th scope="col">Current (g)</th>
                      <th scope="col">Total Pure (g)</th>
                      <th scope="col">Returned</th>
                      <th scope="col">Closing (g)</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const userId = localStorage.getItem("username");
                        const notification = notifications.find(
                          (notif) =>
                            notif.table_id === item.id.toString() &&
                            notif.viewed === "false"
                        );
                        let rowClass = "";
                        if (notification) {
                          switch (notification.status) {
                            case "accepted":
                              rowClass = "table-secondary";
                              break;
                            case "rejected":
                              rowClass = "table-danger";
                              break;
                            case "requested":
                              rowClass = "table-info";
                              break;
                          }
                        }
                        // Return-type aware display
                        const isPure   = item.return_type === "Pure";
                        const isAmount = item.return_type === "Amount";

                        // "Returned" cell
                        let returnedCell;
                        if (isPure) {
                          const pureVal = parseFloat(item.pure) || 0;
                          returnedCell = (
                            <span className="text-success fw-semibold">
                              {pureVal.toFixed(3)} g
                            </span>
                          );
                        } else if (isAmount) {
                          const amtVal = parseFloat(item.amount) || 0;
                          returnedCell = (
                            <span className="text-primary fw-semibold">
                              ₹{amtVal.toFixed(2)}
                            </span>
                          );
                        } else {
                          returnedCell = <span className="text-muted">-</span>;
                        }

                        // Closing balance (always grams)
                        const closeVal = parseFloat(item.close) || 0;
                        const closeDisplay = closeVal === 0
                          ? <span className="badge bg-success">Cleared</span>
                          : <span className="text-danger fw-semibold">{closeVal.toFixed(3)} g</span>;

                        return (
                          <tr key={item.id} className={rowClass}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.retailer_id}</td>
                            <td>{item.supplier_id || "-"}</td>
                            <td>{formatDate(item.retailer_date)}</td>
                            <td>{item.retailer_details?.name || item.supplier_details?.name || "-"}</td>
                            <td>{item.items?.length ?? "-"}</td>
                            <td>
                              <span className={`badge ${
                                isPure ? "bg-warning text-dark"
                                : isAmount ? "bg-info text-dark"
                                : "bg-secondary"
                              }`}>
                                {item.return_type || "-"}
                              </span>
                            </td>
                            <td>{parseFloat(item.opening || 0).toFixed(3)} g</td>
                            <td>{parseFloat(item.current || 0).toFixed(3)} g</td>
                            <td>{parseFloat(item.total_pure || 0).toFixed(3)} g</td>
                            <td>{returnedCell}</td>
                            <td>{closeDisplay}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() => handleUpdateRetailer(item.id)}
                              >
                                <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleOpenModal(item.id, item.retailer_id)
                                }
                              >
                                <i className="fa-solid fa-trash text-danger fs-6"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={() =>
                                  handleprint(item.id, item.retailer_id)
                                }
                              >
                                <i className="fa-solid fa-print text-secondary fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="13" className="text-center">
                          No retailers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${currentPage === totalPages || totalPages === 0
                          ? "disabled"
                          : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${currentPage === totalPages || totalPages === 0
                          ? "disabled"
                          : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="notificationModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="notificationModalLabel"
              >
                Send {actionType} Request to Admin
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeNotificationModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <p className="text-center">
                  Do you want to request to {actionType.toLowerCase()} this
                  retailer?
                </p>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm px-4 me-2"
                    onClick={closeNotificationModal}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm px-4"
                    disabled={isSubmitting}
                    onClick={handleNotificationSubmit}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you really want to delete this
                <span className="text-primary"> ({getdeletename})</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* View All Retailers Modal */}
      <div
        className={`modal fade ${showViewRetailersModal ? "show" : ""}`}
        style={{
          display: showViewRetailersModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Retailers Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowViewRetailersModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-end mb-3 gap-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleViewPrint}
                >
                  <i className="fa-solid fa-print me-2"></i>Print
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={exportViewRetailersPDF}
                >
                  <i className="fa-solid fa-file-pdf me-2"></i>PDF
                </button>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>S.No</th>
                      <th>Retailer ID</th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Address</th>
                      <th>Status</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {retailerDetails.length > 0 ? (
                      retailerDetails.map((retailer, index) => (
                        <tr key={retailer.id || index}>
                          <td>{index + 1}</td>
                          <td>{retailer.retailer_id || "-"}</td>
                          <td>{retailer.name || "-"}</td>
                          <td>{retailer.mobile || "-"}</td>
                          <td>{retailer.address || "-"}</td>
                          <td>
                            <span className={`badge ${retailer.status === 'Active' ? 'bg-success' : 'bg-secondary'}`}>
                              {retailer.status || "Inactive"}
                            </span>
                          </td>
                          <td>{formatDate(retailer.created_date) || "-"}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() => openEditRetailerModal(retailer)}
                              title="Edit Retailer"
                            >
                              <i className="fa-solid fa-pen-to-square text-primary"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          No retailers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowViewRetailersModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {(showModal || deleteShowModals || showAddRetailerModal || showViewRetailersModal || showEditRetailerModal) && (
        <div className="modal-backdrop fade show"></div>
      )}

      {/* Edit Retailer Modal */}
      {showEditRetailerModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          tabIndex="-1"
          onClick={() => setShowEditRetailerModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "500px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-primary">Edit Retailer</h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setShowEditRetailerModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Retailer No</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={editRetailerId}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${editFormErrors.name ? "is-invalid" : ""}`}
                    placeholder="Enter Name"
                    value={editData.name}
                    onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                  />
                  {editFormErrors.name && <div className="invalid-feedback">{editFormErrors.name}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Mobile Number <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength="10"
                    className={`form-control ${editFormErrors.mobile ? "is-invalid" : ""}`}
                    placeholder="Enter 10-digit Mobile"
                    value={editData.mobile}
                    onChange={(e) => {
                      if (/^\d{0,10}$/.test(e.target.value)) {
                        setEditData({ ...editData, mobile: e.target.value });
                      }
                    }}
                  />
                  {editFormErrors.mobile && <div className="invalid-feedback">{editFormErrors.mobile}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Address <span className="text-danger">*</span></label>
                  <textarea
                    className={`form-control ${editFormErrors.address ? "is-invalid" : ""}`}
                    placeholder="Enter Address"
                    rows="2"
                    value={editData.address}
                    onChange={(e) => setEditData({ ...editData, address: e.target.value })}
                  />
                  {editFormErrors.address && <div className="invalid-feedback">{editFormErrors.address}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Status <span className="text-danger">*</span></label>
                  <select
                    className={`form-select ${editFormErrors.status ? "is-invalid" : ""}`}
                    value={editData.status}
                    onChange={(e) => setEditData({ ...editData, status: e.target.value })}
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {editFormErrors.status && <div className="invalid-feedback">{editFormErrors.status}</div>}
                </div>

                <div className="d-flex gap-2 justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => setShowEditRetailerModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleEditRetailerSubmit}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Retailer;